import { create } from "zustand";
import { InvestorAmlDocument } from "../api/transformers/document";
import { DocAPI } from "../api";

type InvestorAmlDocumentStore = {
  data: InvestorAmlDocument[],
  loading: boolean;
  error: unknown;
  fetchData: (investorId: string) => Promise<void>;
}
const useInvestorAmlDocumentStore = create<InvestorAmlDocumentStore>((set) => ({
  data: [],
  loading: true,
  error: null,
  // actions
  fetchData: async (investorId) => {
    set({ loading: true, error: null, data: [] });
    try {
      const result = await DocAPI.getInvestorAmlDocuments(investorId);
      set({ data: result, loading: false });
    } catch (err) {
      console.error(err);
      set({ error: err, loading: false });
    }
  }
}));

export default useInvestorAmlDocumentStore;
